import {
  Component,
  computed,
  input,
  ChangeDetectionStrategy,
} from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { Button } from '../button/button.component';

@Component({
  selector: 'procure-sidenav-toggle-button',
  templateUrl: './sidenav-toggle-button.component.html',
  styleUrl: './sidenav-toggle-button.component.scss',
  imports: [MatTooltip, MatIcon, Button],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class SidenavToggleButton {
  readonly placement = input.required<'left' | 'right'>();
  readonly isExpanded = input.required<boolean>();

  readonly icon = computed(() => {
    const expanded = this.isExpanded();
    const left = this.placement() === 'left';

    if (left) {
      return expanded ? 'chevron_left' : 'chevron_right';
    } else {
      return expanded ? 'chevron_right' : 'chevron_left';
    }
  });
}
